<div class="fact-row" [class.fact-row--last]="isLast()" [formGroup]="currentFact()">
  <div class="drag-icon" qaiDragHandle>
    <qai-icon [kind]="'drag'" [color]="readOnly() ? '#9E9E9E' : 'var(--fg-brand-primary)'" [size]="'16px'" />
  </div>
  <div class="fact-fields">
    <qai-field
      [label]="'simulationBuilder.FACT_MESSAGE_LABEL' | transloco"
      [description]="'simulationBuilder.FACT_MESSAGE_DESCRIPTION' | transloco"
    >
      <textarea
        qai-textarea
        autosize
        qaiTrimLeading
        qaiPasteClean
        formControlName="rawText"
      ></textarea>
    </qai-field>

    @if (showIncorrectText()) {
      <qai-field
        [label]="'simulationBuilder.FACT_INCORRECT_ANSWER_LABEL' | transloco"
        [description]="'simulationBuilder.FACT_INCORRECT_ANSWER_DESCRIPTION' | transloco"
      >
        <textarea
          qai-textarea
          autosize
          qaiTrimLeading
          qaiPasteClean
          formControlName="displayTextIncorrect"
        ></textarea>
      </qai-field>
    } @else {
      <button
        type="button"
        class="reveal-incorrect-text-link"
        (click)="revealIncorrectText()"
        [disabled]="readOnly()"
      >
        {{ 'simulationBuilder.SHOW_INCORRECT_ANSWER_TEXT' | transloco }}
      </button>
    }
  </div>
    <button
      type="button"
      class="delete-icon"
      (click)="handleDeleteFact()"
      [disabled]="readOnly()"
    >
      <qai-icon [kind]="'trash'" [color]="readOnly() ? '#9E9E9E' : 'var(--fg-brand-primary)'" [size]="'16px'" />
    </button>
</div>
